/** Paid PAYLINE (QR prepago): no Modificar — solo V (preparar).
 *  Tras Reabrir (payment limpio, IsPaid=false) se puede editar.
 *  Click mesa verde abre comanda nueva (TableTickets excluye pagados). */
export function isPaidPaylineLocked(ticket: { IsPaid?: boolean; payment?: string } | null | undefined): boolean {
    return !!(ticket?.IsPaid && ticket.payment == 'PAYLINE');
}
